import { useContext, useEffect, useState } from "react";

import CustomDateInput from "../../../helperComponents/CustomDateInput";
import OnboardingBoilerplate from "./OnboardingBoilerplate";
import { BiCamera, BiDonateHeart } from "react-icons/bi";
import styled from "styled-components";
import ImagePicker from "../../../editors/ImagePicker";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../helperComponents/CustomButton";
import { BsApple } from "react-icons/bs";
import { IoPeopleOutline } from "react-icons/io5";
import { TbBuildingSkyscraper } from "react-icons/tb";
import accountTypes from "../../../../data/accountTypes";

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const Text = styled.div`
  font-size: 15px;
  opacity: 0.7;
`;

const InfoSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin: 0 0;
  margin-top: 0;

  .active {
    box-shadow: 0 5px 0px 0px var(--element);
    border: 1px solid var(--element) !important;
    color: var(--element);
  }

  .inactive {
    transform: scale(0.9);
    opacity: 0.65;
    color: var(--elementDim);
  }

  .infoBox {
    cursor: pointer;
    transition: 0.25s ease-in-out;
    border: 1px solid;
    /* color: var(--element); */
    padding: 25px;
    /* max-width: 80vw; */
    margin: auto;
    width: 100%;
    display: flex;
    border-radius: 20px;
    flex-direction: row;
    gap: 15px;

    .infoText {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    img {
      height: 60px;
      /* margin-bottom: 0.5rem; */
    }

    h3 {
      margin: 0;
      font-size: 15px;
      font-weight: 700;
    }

    p {
      margin: 0;
      opacity: 0.7;
      padding: 0;
      margin-top: 0;
      font-size: 12px;
      font-weight: 500;
      /* color: var(--elementDim); */
    }
  }

  @media (min-width: 1024px) {
    flex-direction: column;
    justify-content: space-around;
    gap: 23px;
    /* margin-top: 120px; */

    .infoBox {
      max-width: 25vw;
      text-align: left;
      margin: 0;
    }
  }
`;

const Icon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
`;

const IconImage = styled.img`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  height: 100px;
  width: 100px;
  object-fit: contain;
`;

export default function AskAccountType({ asEditPage }) {
  const { loggedInUser, setLoggedInUser, colorMode } = useContext(Context);
  const [value, setValue] = useState("INDIVIDUAL");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (loggedInUser)
      if (loggedInUser.accountType) setValue(loggedInUser.accountType);
  }, [loggedInUser]);

  function selectType(newType) {
    return () => {
      setValue(newType);
    };
  }

  return (
    <OnboardingBoilerplate
      editPageTitle="Account Type"
      asEditPage={asEditPage}
      title={"You are?"}
      desc={"Please! select account type"}
      onSubmit={onSubmit}
      loading={loading}
    >
      <InfoSection>
        {accountTypes.map((item) => (
          <div
            className={`infoBox ${value == item.value ? "active" : "inactive"}`}
            onClick={selectType(item.value)}
          >
            <IconImage
              src={item.image}
              style={{ filter: `invert(${colorMode == "DARK" ? "1" : "0"})` }}
            ></IconImage>

            <div className="infoText">
              <h3>{item.label}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </InfoSection>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    setLoading(true);

    try {
      await serverLine.patch("/me", { changes: { accountType: value } });
      setLoading(false);

      let newLoggedInUser = { ...loggedInUser, accountType: value };
      setLoggedInUser(newLoggedInUser);

      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
